import { EyeOpenIcon } from "@sanity/icons";
import { lazy } from "react";
import { defineLocaleResourceBundle, definePlugin } from "sanity";
import { route } from "sanity/router";
const visionLocaleNamespace = "vision", visionUsEnglishLocaleBundle = defineLocaleResourceBundle({
  locale: "en-US",
  namespace: visionLocaleNamespace,
  resources: () => import("./resources.js")
}), visionTool = definePlugin((options) => {
  const {
    name,
    title,
    icon,
    ...config
  } = options || {};
  return {
    name: "@sanity/vision",
    tools: [{
      name: name || "vision",
      title: title || "Vision",
      icon: icon || EyeOpenIcon,
      component: lazy(() => import("./SanityVision.js")),
      options: config,
      router: route.create("/*"),
      __internalApplicationType: "sanity/vision"
    }],
    i18n: {
      bundles: [visionUsEnglishLocaleBundle]
    }
  };
});
export {
  visionLocaleNamespace,
  visionTool
};
//# sourceMappingURL=index.js.map
